import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ClienteAutocompleteEditar from "./AutocompleteClienteEditar";

const EditarClienteEspecialModal = ({ open, onClose, id }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [cliente, setCliente] = useState({
        idCliente: 0,
        razonSocial: "",
        comentario: "",
        especial: false,
        tipo: ""
    });

    const [evidencia, setEvidencia] = useState({
        documento: "",
        extension: "",
    })

    useEffect(() => {
        if (id) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ClientesEspeciales/ObtenerInfoCliente?idCliente=${id}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    // console.log(result)
                    const clienteData = result[0];
                    setCliente({
                        idCliente: clienteData.idcliente || 0,
                        razonSocial: clienteData.razonSocial || "",
                        comentario: clienteData.comentarios || "",
                        especial: clienteData.estatus === "True",
                        tipo: clienteData.tipo_cliente || ""
                    });
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    console.error("Error al obtener los datos del cliente:", error);
                });
        }
    }, [id]);

    // console.log(cliente)

    const EditarCliente = () => {
        if (cliente.idCliente === "" || cliente.idCliente === null || cliente.idCliente === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe seleccionar un cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (cliente.comentario === "" || cliente.comentario === null || cliente.comentario === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe escribir un comentario",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (cliente.especial === "" || cliente.especial === null || cliente.especial === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe seleccionar un estado para el cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (cliente.tipo === "" || cliente.tipo === null || cliente.tipo === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe seleccionar un tipo para el cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (cliente.tipo === "N" && evidencia.documento === "" || cliente.tipo === "F" && evidencia.documento === "") {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe subir un documento como evidencia para este tipo de cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        const post = {
            idcliente: id,
            comentarios: cliente.comentario,
            estatus: cliente.especial,
            tipo_cliente: cliente.tipo,
            usuario: 0
          };

        setLoader({ ...loader, mostrar: true });
        request
            .post("ClientesEspeciales", post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "CLIENTES ESPECIALES",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CLIENTES ESPECIALES", JSON.stringify(error), "error");
            });
    };

    const handleSelectCliente = (id, razonSocial) => {
        setCliente({
            ...cliente,
            idCliente: id,
            razonSocial: razonSocial,
        });
    };

    const GetFile = ({ target }) => {
        const file = target.files[0].name.split(".");
        if (file.length > 2) {
            Swal.fire("Clientes", "Archivo invalido", "error");
            return;
        }

        if (
            file[1] !== "jpg" &&
            file[1] !== "jepg" &&
            file[1] !== "pdf" &&
            file[1] !== "PDF"
        ) {
            Swal.fire("Clientes", "Archivo con formato no valido", "error");
            target.value = "";
            return;
        }
        var fReader = new FileReader();
        fReader.readAsDataURL(target.files[0]);
        fReader.onloadend = function (event) {
            setEvidencia({
                ...evidencia,
                documento: event.target.result,
                extension: file[1],
            });
        };
    };

    // console.log(cliente)
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="agregar-cliente-especial-modal-formulario">
                    <div className="agregar-cliente-especial-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"EDITAR CLIENTE ESPECIAL"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`agregar-cliente-especial-modal-agregar-convenio`}>
                                    <div className="agregar-cliente-especial-modal-agregar-convenio-container scroll-4">
                                        <h3 className="titulo-seccion">Modificar Información de Cliente Especial</h3>
                                        <ClienteAutocompleteEditar onSelectCliente={handleSelectCliente} idCliente={cliente.idCliente}/>
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Comentario"
                                            sx={{ mt: 2 }}
                                            value={cliente.comentario}
                                            onChange={(e) => {
                                                setCliente({
                                                    ...cliente,
                                                    comentario: e.target.value,
                                                });
                                            }}
                                        />
                                        <TextField
                                            className="input-medio-comunicacion"
                                            fullWidth
                                            size="small"
                                            label="Estado"
                                            select
                                            type="text"
                                            value={cliente.especial}
                                            onChange={(e) => {
                                                setCliente({
                                                    ...cliente,
                                                    especial: e.target.value,
                                                });
                                            }}
                                            sx={{ mt: 2 }}
                                        >
                                            <MenuItem value={true}>Vigente</MenuItem>
                                            <MenuItem value={false}>Cancelado</MenuItem>
                                        </TextField>
                                        {/* <TextField
                                            className="input-medio-comunicacion"
                                            fullWidth
                                            size="small"
                                            label="Tipo"
                                            select
                                            type="text"
                                            value={cliente.tipo}
                                            onChange={(e) => {
                                                setCliente({
                                                    ...cliente,
                                                    tipo: e.target.value,
                                                });
                                            }}
                                            sx={{ mt: 2 }}
                                        >
                                            <MenuItem value={'P'}>Plataforma</MenuItem>
                                            <MenuItem value={'N'}>No Paga Intereses</MenuItem>
                                            <MenuItem value={'F'}>No Firma Pagare</MenuItem>
                                        </TextField>
                                        <TextField
                                            id="clientes-documento"
                                            type="file"
                                            onChange={GetFile}
                                            sx={{ mb: 2, mt: 2 }}
                                        /> */}
                                    </div>
                                    <div className="agregar-cliente-especial-modal-buttons">
                                        <button
                                            className="agregar-cliente-especial-modal-button-guardar"
                                            onClick={() => EditarCliente()}
                                        >
                                            Editar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default EditarClienteEspecialModal;